import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { StyledDialog, Content } from './styles';

const HelpCheckout = ({ onClose, open }) => {
  const handleCancel = () => {
    if (window.localStorage.getItem('checkout_pagseguro')) {
      window.localStorage.removeItem('checkout_pagseguro');
    }
    onClose();
  };

  return (
    <StyledDialog
      disableBackdropClick
      disableEscapeKeyDown
      open={open}
      onClose={() => onClose(false)}
    >
      <Content>
        <Title>Pagamento Serviço Atermação</Title>
        <Text>Seu pedido para o serviço de Atermação está em processamento pelo PagSeguro.</Text>
        <Text>
          Assim que recebermos a liberação automática, você será redirecionado para a próxima etapa.
        </Text>
        <Text>Para pagamentos por Pix e Cartões este procedimento costuma ser rápido, mas alguns cartões e pagamentos em boleto demoram até 24 horas para serem liberados.</Text>
        <Text>
          Não se preocupe, você receberá também um e-mail de confirmação para início dos preocedimentos, portanto, se preferir pode fechar está página.
        </Text>
        <Text>
          Qualquer dúvida entrem em contato pelos canais de ajuda ou escreva para
          {' '}
          <a href="mailto:atendimento@loitlegal.com.br">atendimento@loitlegal.com.br</a>
        </Text>
        <Button href="/home">Voltar a tela inicial</Button>
        <Button
          className="unset"
          variant="outlined"
          onClick={handleCancel}
        >
          Cancelar
        </Button>
      </Content>
    </StyledDialog>
  );
};

HelpCheckout.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default HelpCheckout;
